<template>

<app-table empty-message="This convention has not been issued any credits." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column />

		<app-table-column text="Title" />

		<app-table-column text="Date" />

		<app-table-column text="Amount" />

		<app-table-column />

	</app-table-head>

	<app-table-body>

		<app-table-row :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-label :text="$constants.billing.credit.statusName[item.status]" :type="$constants.billing.credit.statusTheme[item.status]" :subtext="item.reference" />

			<app-table-cell-text :text="item.title" />

			<app-table-cell-text :text="item.date | localDate('MM/DD/YYYY h:mma')" />

			<app-table-cell-text :text="item.amount | formatMoney" />

			<app-table-cell-action icon="remove" theme="red" v-tooltip="'Cancel credit'" v-on:click="$emit('cancel', item)" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: '120px 1fr 240px 120px 40px'
		}
	
	}

}

</script>

<style scoped>

</style>